import { Component } from '@angular/core';
import { SharedModule } from '../../shared/shared.module';
import { TranslatePipe } from '@ngx-translate/core';
import { SubmitApplicationComponent } from '../submit-application/submit-application.component';

@Component({
  selector: 'app-careers',
  imports: [SharedModule, SubmitApplicationComponent],
  templateUrl: './careers.component.html',
  styleUrl: './careers.component.css',
})
export class CareersComponent {
  isOpened = false;

  openSubmitApplication() {
    this.isOpened = true;
  }
}
